// Libs
import _map from 'lodash/map'
import { createSelector } from 'reselect'

// Constants
import {
  PROP_SAMPLING_JOB_ID,
} from 'fc-model-sampling-jobs'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Selectors
import jobsOfSelectedField$ from './jobsOfSelectedField'

// Exports

export default createSelector(
  [
    jobsOfSelectedField$,
  ],
  (jobs) => {
    return emptyArrayOr(_map(jobs, function (job) {
      return {
        value: job[PROP_SAMPLING_JOB_ID],
        label: job[PROP_SAMPLING_JOB_ID],
      }
    }))
  }
)
